import styled from "styled-components";

interface IProps {
  small?: boolean;
}

export const Button = styled.button<IProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  border: none;
  box-shadow: none;
  cursor: pointer;
  font-size: ${(props) => (props.small ? "14px" : "18px")};
  color: ${({ theme }) => (theme.mode === "dark" ? "#ffffff" : "#787878")};

  background-color: transparent !important;

  &:focus,
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  div.loading {
    width: 20px;
    height: 20px;
    border: 3px solid ${(props) => `${props.theme.colors.primary}34`};

    border-radius: 50%;
    border-top-color: ${({ theme }) => theme.colors.primary};

    margin-right: 10px;

    animation: rotate 1s linear infinite;
  }

  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;
